<template>
  <div>
    <base-summary :isHeader="false" :isFooter="false">
      <div class="c-base-summary__wrapper">
        <p>{{ reason }}</p>
      </div>
    </base-summary>
    <router-link
      :to="{ name: 'carteira' }"
      class="button is-black is-outlined is-big margin-bottom"
    >
      Ok, entendi!
    </router-link>
  </div>
</template>

<script>
import BaseSummary from '@/components/Wallet/BaseSummary.vue'

export default {
  props: {
    reason: {
      type: String,
      required: true,
    },
  },

  components: {
    BaseSummary,
  },
}
</script>

<style lang="scss" scoped></style>
